"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSITE_URL_REGEX = exports.PROJECT_ID_REGEX = exports.CARBON_AVOIDANCE_AMOUNT_REGEX = void 0;
/**
 * Permits whole numbers, as well as decimals up to two decimal places.
 */
exports.CARBON_AVOIDANCE_AMOUNT_REGEX = /^\d*(\.\d{0,2})?$/;
/**
 * Permits whole numbers only, between 2 and 5 characters in length.
 */
exports.PROJECT_ID_REGEX = /^\d{2,5}$/;
/**
 * Used for constraining the User.link field, see https://stackoverflow.com/a/3809435
 */
exports.WEBSITE_URL_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnZXhlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9yZWdleGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ1UsUUFBQSw2QkFBNkIsR0FBRyxtQkFBbUIsQ0FBQztBQUVqRTs7R0FFRztBQUNVLFFBQUEsZ0JBQWdCLEdBQUcsV0FBVyxDQUFDO0FBRTVDOztHQUVHO0FBQ1UsUUFBQSxpQkFBaUIsR0FDNUIsbU5BQW1OLENBQUMifQ==